const INSTALLATION_TYPE_KEYS = ["wordpress", "git", "files", "go"];

export default {
	computed: {
		availableInstallationTypes() {
			const enabled = new Set();

			for (const service of this.services) {
				const types = service.onboarding?.installation_type;
				if (!types) {
					continue;
				}
				for (const key of INSTALLATION_TYPE_KEYS) {
					if (types[key] === true) {
						enabled.add(key);
					}
				}
			}

			return INSTALLATION_TYPE_KEYS.filter((key) => enabled.has(key));
		},

		getFirstInstallationType() {
			return this.availableInstallationTypes[0];
		},

		canInstallWordpress() {
			return this.availableInstallationTypes.includes("wordpress");
		},

		canInstallFromGit() {
			return this.availableInstallationTypes.includes("git");
		},

		canInstallFromFiles() {
			return this.availableInstallationTypes.includes("files");
		},

		canInstallFromPanelalphaGo() {
			return this.availableInstallationTypes.includes("go");
		},
	},
};
